/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1553
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.default = undefined
var r = {
  attributeNames: {
    styleName: "className"
  },
  generateScopedName: "[path]___[name]__[local]___[hash:base64:5]",
  handleMissingStyleName: "throw"
}
exports.default = r
